export const CHANGE_LANG = 'cboard/LanguageProvider/CHANGE_LANG';
export const SET_LANGS = 'cboard/LanguageProvider/SET_LANGS';
